import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const app = <App />;

// React StrictMode mounts effects twice in development. This application has
// data-loading effects on every portal, so enabling it globally duplicated all
// initial API requests and made local navigation appear much slower. It remains
// available as an explicit diagnostic option without affecting normal usage.
root.render(
  process.env.REACT_APP_ENABLE_STRICT_MODE === 'true'
    ? <React.StrictMode>{app}</React.StrictMode>
    : app
);
